import React, { Children, useCallback, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './index.scss';

const cx = classNames.bind(styles);

interface ContextMenuProps {
  container: React.RefObject<HTMLElement>;
  children: React.ReactNode;
  width?: number;
}

const ContextMenu:React.FC<ContextMenuProps> = ({
  children, container, width = 293,
}) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });


  const { x, y } = menuPosition;
  const style = {
    top: y,
    left: x,
    width,
  };

  const handleContextMenu = useCallback((event) => {
    const element = container.current;
    if (element?.contains(event.target)) {
      event.preventDefault();
      setMenuVisible(!menuVisible);
      let xCoordinate = event.clientX;
      if (xCoordinate + width > window.innerWidth) {
        xCoordinate = window.innerWidth - width;
      }
      setMenuPosition({ x: xCoordinate, y: event.clientY + window.scrollY });
    } else {
      setMenuVisible(false);
    }
  }, [menuVisible, container, width]);

  const handleClick = () => {
    setMenuVisible(false);
  };

  useEffect(() => {
    document.addEventListener('contextmenu', handleContextMenu, true);
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu, true);
      document.removeEventListener('click', handleClick);
    };
  }, [handleContextMenu]);

  if (!menuVisible) return null;

  return (
    <div style={style} className={cx('ContextMenu')}>
      {Children.map(children, child => (
        <>
          {child}
        </>
      ))}
    </div>
  );
};

export default ContextMenu;
